<template>
  <div class="timeseries-table">
    <v-data-table dense :headers="headers" :items="tableStats" item-key="Time">
      <template slot="body.append" v-if="tableStats.length">
        <tr class="font-weight-bold">
          <th class="title">Total</th>
          <template v-for="d in days">
            <th class="title" :key="d">{{ sumField(d) }}</th>
          </template>
          <th class="title">{{ sumField("Avg") }}</th>
        </tr>
      </template>
      <template v-slot:item="{ item }">
        <tr>
          <td>
            {{ item.Time }}
          </td>
          <template v-for="[i, column] of Object.entries(item)">
            <td :key="i" v-if="i !== 'Time' && i !== 'Avg'">
              <span>{{ splitFigure(column).figure }}</span>
              <span :class="splitFigure(column).color">{{
                splitFigure(column).staff
              }}</span>
            </td>
          </template>
          <td>
            {{ item.Avg }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Object },
    staffSwitch: { type: Boolean },
    staffCapacity: { type: String },
    interval: { type: Number },
  },
  data: function () {
    return {
      newStaffSwitch: this.staffSwitch,
      newStaffCapacity: this.staffCapacity,
      newInterval: this.interval,
    };
  },
  watch: {
    staffSwitch() {
      this.newStaffSwitch = this.staffSwitch;
    },
    staffCapacity() {
      this.newStaffCapacity = parseFloat(this.staffCapacity);
    },
    interval() {
      this.newInterval = this.interval;
    },
  },
  computed: {
    headers() {
      let headers = [];
      if (this.data) {
        if (this.data["xAxis"]) {
          let weekdays = Object.keys(this.data["yAxis"]);
          weekdays.sort();
          let time = [{ text: "Time", sortable: false, value: "Time" }];
          for (let i in weekdays) {
            headers.push({
              text: this.getWeekdayName(weekdays[i]),
              value: weekdays[i],
              sortable: false,
            });
          }
          headers = time.concat(headers);
          headers.push({ text: "Avg", value: "Avg", sortable: false });
        }
      }
      return headers;
    },
    tableStats() {
      if (this.data) {
        if (this.data["yAxis"] && this.data["xAxis"]) {
          let weekdays = Object.keys(this.data["yAxis"]);
          let datasets = [];
          for (let i in this.data["xAxis"]) {
            let temp = {
              Time: this.data["xAxis"][i],
            };
            let avg = 0;
            let sum = 0;
            for (let weekday in weekdays) {
              temp[weekdays[weekday]] = this.data["yAxis"][weekdays[weekday]][
                i
              ];
              sum += temp[weekdays[weekday]];
              if (this.newStaffSwitch) {
                let staff =
                  Math.round(
                    (temp[weekdays[weekday]] /
                      this.newStaffCapacity /
                      this.newInterval) *
                      60 *
                      10
                  ) / 10;
                temp[weekdays[weekday]] += ` (${staff})`;
              }
            }
            avg = Math.round((sum / weekdays.length) * 100) / 100;
            if (this.newStaffSwitch) {
              let staff =
                Math.round(
                  (avg / this.newStaffCapacity / this.newInterval) * 60 * 10
                ) / 10;
              avg += ` (${staff})`;
            }
            temp["Avg"] = avg;
            datasets.push(temp);
          }
          return datasets;
        }
      }
      return [];
    },
    days() {
      if (this.data["yAxis"]) {
        if (Object.keys(this.data["yAxis"]).length > 0) {
          return Object.keys(this.data["yAxis"]);
        }
      }
      return [];
    },
  },
  methods: {
    getWeekdayName(weekday) {
      let sorted = {
        0: "Monday",
        1: "Tuesday",
        2: "Wednesday",
        3: "Thursday",
        4: "Friday",
        5: "Saturday",
        6: "Sunday",
      };
      return sorted[weekday];
    },
    splitFigure(column) {
      let color = "red--text";
      if (this.staffSwitch) {
        let staff = parseFloat(column.split(" (")[1].slice(0, -1));
        if (staff <= 1) {
          color = "green--text";
        } else if (staff <= 1.3) {
          color = "orange--text";
        } else if (staff <= 1.5) {
          color = "orange--text text--darken-2";
        }
        return {
          figure: column.split(" (")[0],
          staff: ` (${staff})`,
          color: color,
        };
      }
      return { figure: column, staff: "", color: undefined };
    },
    sumField(key) {
      var val = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, Total: 0 };
      if (this.tableStats.length) {
        val = this.tableStats.reduce((previousValue, currentValue) => {
          let _0 = this.parseToFloat(previousValue[0], currentValue[0]);
          let _1 = this.parseToFloat(previousValue[1], currentValue[1]);
          let _2 = this.parseToFloat(previousValue[2], currentValue[2]);
          let _3 = this.parseToFloat(previousValue[3], currentValue[3]);
          let _4 = this.parseToFloat(previousValue[4], currentValue[4]);
          let _5 = this.parseToFloat(previousValue[5], currentValue[5]);
          let _6 = this.parseToFloat(previousValue[6], currentValue[6]);
          return {
            0: Math.round(_0 * 100) / 100,
            1: Math.round(_1 * 100) / 100,
            2: Math.round(_2 * 100) / 100,
            3: Math.round(_3 * 100) / 100,
            4: Math.round(_4 * 100) / 100,
            5: Math.round(_5 * 100) / 100,
            6: Math.round(_6 * 100) / 100,
            Avg:
              Math.round(((_0 + _1 + _2 + _3 + _4 + _5 + _6) / 7) * 100) / 100,
          };
        });
      }
      return val[key];
    },
    parseToFloat(prev, curr) {
      if (this.newStaffSwitch) {
        if (prev) prev = parseFloat(prev.toString().split(" ")[0]);
        if (curr) curr = parseFloat(curr.toString().split(" ")[0]);
      }
      return prev + curr || 0;
    },
  },
};
</script>
